const TarifOption = 3113;

export default TarifOption;